<template>
    <card :loading="loading">
        <div class="flex items-center dark:text-white">
            <div
                class="-left-1.5 mr-1 h-3 w-3 rounded-full border border-white dark:border-gray-900"
                :class="{
                    'bg-green-500': ['authorized', 'completed'].includes(
                        transfer.status,
                    ),
                    'bg-red-500': ['rejected', 'rejected_on_file'].includes(
                        transfer.status,
                    ),
                    'bg-yellow-500': [
                        'pending_authorization',
                        'pending_execution',
                        'pending_change',
                    ].includes(transfer.status),
                    'bg-gray-500': !transfer,
                }"
            ></div>
            <span v-if="transfer">
                <span class="mr-1">{{ transfer.created_at }}</span
                >Pix {{ statusName }} em {{ transfer.provider }}
            </span>
            <span v-else class="flex w-full flex-col gap-3">
                <span class="text-sm dark:text-white">
                    Transferência não encontrada
                </span>
                <div class="flex flex-col gap-2">
                    <select
                        v-model="selectedAccountId"
                        class="w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm text-black focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 dark:border-gray-600 dark:bg-gray-800 dark:text-white"
                    >
                        <option
                            v-for="account in accounts"
                            :key="account.id"
                            :value="account.id"
                        >
                            {{ account.name }} - Ag: {{ account.payer_agency }}
                            Cc: {{ account.payer_account }}
                        </option>
                    </select>
                    <button
                        @click.prevent="submit"
                        :disabled="!selectedAccountId || loading"
                        class="rounded bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        <spinner class="mr-2 inline" v-if="loading" />
                        Enviar Transferência
                    </button>
                </div>
            </span>
        </div>
    </card>
</template>

<script>
import Card from "../layouts/Card.vue";
import Spinner from "../forms/Spinner.vue";

export default {
    components: { Spinner, Card },
    props: ["cashout"],

    data() {
        return {
            loading: false,
            transfer: false,
            accounts: [],
            selectedAccountId: null,
        };
    },

    computed: {
        statusName() {
            if (!this.transfer) {
                return "";
            }

            switch (this.transfer.status) {
                case "pending_authorization":
                    return "Autorização Pendente";
                case "pending_execution":
                    return "Execução Pendente";
                case "authorized":
                    return "Autorizado";
                case "completed":
                    return "Transferido";
                case "rejected":
                    return "Rejeitado";
                case "pending_change":
                    return "Mudança Pancelado";
                case "rejected_on_file":
                    return "Rejeitado";
            }
        },
    },

    mounted() {
        this.fetch();
        this.fetchAccounts();
    },

    methods: {
        fetch() {
            this.loading = true;
            axios
                .get("/api/cashout/" + this.cashout.id + "/transfer")
                .then(({ data }) => {
                    this.transfer = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        fetchAccounts() {
            axios
                .get("/api/financial/wire-transfer-accounts")
                .then(({ data }) => {
                    this.accounts = data.data;
                    const defaultAccount = this.accounts.find(
                        (account) => account.is_default,
                    );
                    this.selectedAccountId = defaultAccount
                        ? defaultAccount.id
                        : this.accounts[0]?.id;
                })
                .catch((error) => {
                    console.error(
                        "Failed to fetch wire transfer accounts:",
                        error,
                    );
                });
        },
        submit() {
            if (!this.selectedAccountId) {
                return;
            }

            this.loading = true;
            axios
                .post("/api/cashout/" + this.cashout.id + "/transfer", {
                    wire_transfer_account_id: this.selectedAccountId,
                })
                .then(({ data }) => {
                    this.transfer = data;
                    this.fetch();
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
